<template>
    <GuestStudentLayout>
        <b-card
            :title="$t('sign_up').toUpperCase()"
            class="mb-2"
        >
            <ValidationObserver ref="registerForm">
                <b-row>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="tc_no" :rules="!form.passport_number ? 'required|digits:11' : ''" v-slot="{valid, errors}">
                            <b-form-group :label="$t('tc_no')">
                                <b-form-input
                                    size="sm"
                                    v-model="form.national_id"
                                    v-mask="'###########'"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="!!form.passport_number"
                                    class="rounded">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="passport_number" :rules="!form.national_id ? 'required|max:255' : ''" v-slot="{valid, errors}">
                            <b-form-group :label="$t('passport_number')">
                                <b-form-input
                                    v-model="form.passport_number"
                                    :disabled="!!form.national_id"
                                    :class="errors[0] ? 'is-invalid':''"
                                    :state="errors[0] ? false : (valid ? true : null)"/>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="form.name"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="surname" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="form.surname"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="birthdate" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('birthdate')">
                                <select-date v-model="form.birthdate" :state="errors[0] ? false : null" />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="phone" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('telephone')">
                                <b-form-input size="sm" v-model="form.phone"
                                              v-mask="'(5##)-###-####'"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded "></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors }">
                            <b-form-group :label="$t('email_address')">
                                <b-form-input size="sm" v-model="form.email" class="rounded" :state="errors[0] ? false : (valid ? true : null)" ></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="nationality_code" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('nationality')">
                                <country-selectbox valueType="code"
                                                   v-model="form.nationality_code"
                                                   :public="true"
                                                   :placeholder="$t('nationality')"
                                                   :state="errors[0] ? false : null"
                                                   :validate-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>
            <b-col class="d-flex flex-column justify-content-center align-item-center">
                <ProcessingButton class="d-flex justify-content-center mt-4"  :processing="loading"  :label="$t('pin_code') + ' ' + $t('send')" @click="sendVerify" />
                <b-button variant="link" class="mt-3 text-secondary" @click="$router.push('/visitor-student/application/login')">{{ $t('login') }}</b-button>
            </b-col>
        </b-card>

        <CommonModal ref="emailVerification" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
            <template v-slot:CommonModalTitle>
                <template>
                    {{ $t('email_verification').toUpper() }}
                </template>
            </template>
            <template v-slot:CommonModalContent>
                <div class="mb-3">
                    <div class="alert alert-info">
                        <strong>{{ form.email }}</strong>
                    </div>
                    <ValidationObserver ref="formSmsVerify">
                        <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                            <sms-input v-model="pin"
                                       :timerFrom="timer"
                                       @timerExpired="timerExpired"
                            />
                        </ValidationProvider>


                    </ValidationObserver>
                    <div class="d-flex justify-content-end mt-2">
                        <ProcessingButton v-if="timer===0" :label="$t('resend_code')" :variant="'link'" :processing="loading" @click="sendVerify"/>
                    </div>
                    <div>
                        <ProcessingButton v-if="timer>0" :disabled="pin==null"  :label="$t('verify')" :processing="loading" class="d-flex justify-content-center align-item-center mt-3" @click="verify"/>
                    </div>
                </div>
            </template>
        </CommonModal>
    </GuestStudentLayout>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox.vue";
import VisitorStudentApplicationServices from "@/services/VisitorStudentApplicationServices";
import SmsInput from "@/components/elements/SmsInput.vue";
import GuestStudentLayout from "@/modules/visitorStudentApplication/student/layouts/GuestStudentLayout.vue";
export default {
    components: {
        GuestStudentLayout,
        SmsInput,
        ProcessingButton,
        CountrySelectbox
    },
    data(){
        return {
            form:{},
            phone:null,
            loading: false,
            disabled:true,
            pin:null,
            timer:0
        }
    },
    created() {
        if (this.$store.getters['VisitorStudentApplicationStore/isLoggedIn']) {
            this.logout();
        }
    },

    methods:{
        clear(){

        },
        timerExpired(event) {
            this.timer = 0;
        },
        async sendVerify() {
            const isValid = await this.$refs.registerForm.validate();
            if (!isValid) return;

            try {
                this.loading = true;

                if (this.form.phone) {
                    this.form.phone = this.form.phone.replace(/\D/g, '');
                }

                const res = await VisitorStudentApplicationServices.register(this.form);
                this.timer = res.data.data.expires_in;

                this.$refs.emailVerification.$refs.commonModal.show();
                this.$toast.success('api.' + res.data.data.message);
            } catch (error) {
                const errorMessage = error?.data?.message || error?.message || this.$t("api." + error.data.message);

                if (errorMessage === 'APPLICATION_ALREADY_PENDING') {
                    this.$router.push('/visitor-student/application/login');
                }

                this.showErrors(error, this.$refs.registerForm);
            } finally {
                this.loading = false;
            }
        },
        async verify(){
            const isValid = await this.$refs.formSmsVerify.validate()
            if (!isValid) return
            try {
                const data = { pin: this.pin }
                if (this.form.national_id) {
                    data.national_id = this.form.national_id
                } else {
                    data.passport_number = this.form.passport_number
                }

                const res = await VisitorStudentApplicationServices.verify(data)

                const userData = {
                    national_id: this.form.national_id || null,
                    passport_number: this.form.passport_number || null,
                    name: this.form.name,
                    surname: this.form.surname,
                    email: this.form.email,
                    phone: this.form.phone,
                    birthdate: this.form.birthdate,
                    nationality_code: this.form.nationality_code || null,
                    ...res.data.data
                }

                this.$store.dispatch('VisitorStudentApplicationStore/setVisitorApplicationUser', userData)
                this.$store.dispatch('VisitorStudentApplicationStore/setPin', this.pin)
                this.$toast.success(this.$t('registration_successful'))
                this.$router.push('/visitor-student/application/form')
            } catch (err) {
                this.showErrors(err, this.$refs.formSmsVerify)
            }
        },
        logout(){
            this.$store.dispatch('VisitorStudentApplicationStore/logout')
        }
    }
}
</script>

<style scoped>

</style>
